if(!customElements.get('hover-banners')) {
  class ComponentHoverBanners extends HTMLElement {
    constructor() {
      super();
      this.baseImage = this.querySelector('.base-img');
      this.hoverBtns = this.querySelectorAll('.btn-banner');
      this.hoverImages = this.querySelectorAll('.hover-img');
      this.lastHoverImg;
      this.hoverBtns.forEach(btn => {

        btn.addEventListener('mouseover', () => {
          this.baseImage.classList.add('back');
          if(this.lastHoverImg)
            this.lastHoverImg.classList.add('hide');

            this.hoverImages.forEach(img => {
              if(img.classList.contains(btn.dataset.target)){
                this.lastHoverImg = img;
                this.lastHoverImg.classList.remove('hide');
              }
            });  
        });

        btn.addEventListener('mouseleave', () => {
          if(this.lastHoverImg)
            this.lastHoverImg.classList.add('hide');
          this.baseImage.classList.remove('back');
        });

      });

    }



  }
  customElements.define('hover-banners', ComponentHoverBanners);
}